import css from './UnorderedList.module.css'

export function UnorderedList({ children }: { children?: React.ReactNode }) {
    return <ul className={css.unorderedList}>{children}</ul>
}
